import Rellax from 'rellax';

export function initParallax() {
  const rellax = Rellax('.rellax', {
    horizontal: false,
    callback: function (_pos: { x: number; y: number; }) {
      if (this.breakpoints) {
        updateOpacity(this.breakpoints);
      }
    }
  });
}

function updateOpacity(breakpoints: [number, number, number]) {
  const rellaxElems: NodeListOf<HTMLElement> = document.querySelectorAll('.rellax');
  const currentScrollPosition: number = window.pageYOffset;
  const scrollingArea: number = (window.document.documentElement.scrollHeight - window.innerHeight);
  const scrollPositionPercent: number = currentScrollPosition / scrollingArea;
  const currentBreakpoint: string = getCurrentBreakpoint(breakpoints, window.innerWidth);

  rellaxElems.forEach((rellaxElem: HTMLElement) => {
    const opacitySeed: number = getElOpacitySeed(rellaxElem, currentBreakpoint);
    if (opacitySeed > 0) {
      rellaxElem.style.opacity = (1 - scrollPositionPercent * opacitySeed).toString();
    }
  });
}

function getCurrentBreakpoint(breakpoints: [number, number, number], width: number): string {
  if (width < breakpoints[0]) return 'xs';
  if (width >= breakpoints[0] && width < breakpoints[1]) return 'sm';
  if (width >= breakpoints[1] && width < breakpoints[2]) return 'md';
  return 'lg';
};

function getElOpacitySeed(el: HTMLElement, currentBreakpoint: string): number {
  if (el.hasAttribute('data-rellax-' + currentBreakpoint + '-opacity-seed')) {
    return Number(el.getAttribute('data-rellax-' + currentBreakpoint + '-opacity-seed'));
  }
  else if (el.hasAttribute('data-rellax-opacity-seed')) {
    return Number(el.getAttribute('data-rellax-opacity-seed'));
  }
  return 0;
}
